<template>
    <v-dialog
        v-model="isOpen"
        max-width="350"
        @click:outside.prevent="close"
    >
        <v-card class="pa-5" v-if="product">
            <h3 class="text-left">{{product.title}}</h3>
            <v-layout class="d-flex flex-column">
                <v-flex>
                    <v-textarea
                        v-model="commentText"
                        hint="Enter comment"
                        rows="3"
                    ></v-textarea>
                </v-flex>
                <v-flex class="align-center justify-space-around d-flex">
                    <v-btn @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="formSubmit">Save</v-btn>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'stockOrderComment',
    props: ['isOpen', 'closeModal', 'product'],
    data: () => ({
      commentText: ''
    }),
    watch: {
      product () {
        this.commentText = this.product.comment
      }
    },
    methods: {
      formSubmit () {
        this.product.comment = this.commentText
        this.close()
      },
      close () {
        this.commentText = ''
        this.$emit('closeModal')
      }
    }
  }
</script>

<style lang="scss">
</style>
